import { render, staticRenderFns } from "./PatientCardTimeline.vue?vue&type=template&id=39598e22&scoped=true"
import script from "./PatientCardTimeline.vue?vue&type=script&lang=js"
export * from "./PatientCardTimeline.vue?vue&type=script&lang=js"
import style0 from "./PatientCardTimeline.vue?vue&type=style&index=0&id=39598e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39598e22",
  null
  
)

export default component.exports